import React from 'react';
import connect from 'Shared/connect';
import * as styles from './base.scss';
import classnames from 'classnames';
import MyMenigoIcon, { GetIcons } from '../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import Image from 'Shared/ImageFallback';
const MyMenigoMenu = (props) => {
    return (React.createElement("div", { className: styles.listContainer, key: "MyMenigo" }, props.myMenigoItems
        .filter(item => item.disabledForGuestUsers)
        .map(item => (React.createElement("a", { key: item.url, className: classnames(styles.menuLink), href: item.url, tabIndex: props.tabIndex },
        !item.menuIcon ?
            React.createElement(MyMenigoIcon, { name: GetIcons(item.name) }) :
            item.menuIcon.toString().includes('.svg') ?
                React.createElement(Image, { src: item.menuIcon.toString(), className: styles.svg }) :
                React.createElement(Image, { src: item.menuIcon.toString(), className: styles.image }),
        React.createElement("span", null, item.name))))));
};
export default connect((state) => ({
    myMenigoItems: !!state.appShellData.header && state.appShellData.header.myMenigoItems,
    mainMeny: state.mainMenu,
}))(MyMenigoMenu);
